var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sub-visual-wrap fade"
  }, [_c('div', {
    staticClass: "sub-visual pb-lg-60"
  }, [_c('div', {
    staticClass: "sub-visual-tit"
  }, [_c('v-container', [_vm.sh2 ? _c('h2', [_vm._v(_vm._s(_vm.sh2))]) : _c('h2', [_vm._v(_vm._s(_vm.sh))])])], 1), _c('div', {
    staticClass: "sub-visual-bg",
    style: 'background-image:url(' + _vm.bg + ');'
  })]), _c('v-container', [_vm.sh !== '위치안내' ? _c('client-gnb', {
    attrs: {
      "className": "sub-tab-wrap",
      "tabActive": _vm.tabActive,
      "sh": _vm.sh
    }
  }) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }